import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type OrdersState = {
  orderFilter: string;
  selectedDate: Date | null;
  selectedOrderIds: Guid[];
  orderStatusFilters: string[];
  orderTypeFilters: string[];
};

const initialState: OrdersState = {
  orderFilter: "",
  selectedDate: null,
  selectedOrderIds: [],
  orderStatusFilters: [],
  orderTypeFilters: []
};

export const ordersSlice = createSlice({
  name: "orders",
  initialState,
  reducers: {
    clearSelectedOrders(state) {
      state.selectedOrderIds = [];
    },

    setOrderFilter(state, { payload }: PayloadAction<string>) {
      state.orderFilter = payload;
    },

    setOrderStatusFilters(state, { payload }: PayloadAction<string[]>) {
      state.orderStatusFilters = payload;
    },

    setOrderTypeFilters(state, { payload }: PayloadAction<string[]>) {
      state.orderTypeFilters = payload;
    },

    setSelectedDate(state, { payload }: PayloadAction<Date | null>) {
      state.selectedDate = payload;
      state.selectedOrderIds = [];
    },

    selectOrder(state, { payload: orderId }: PayloadAction<Guid>) {
      const orderIdIndex = state.selectedOrderIds.indexOf(orderId);
      if (orderIdIndex === -1) {
        state.selectedOrderIds.push(orderId);
      } else {
        state.selectedOrderIds.splice(orderIdIndex, 1);
      }
    }
  }
});
export const {
  clearSelectedOrders,
  selectOrder,
  setOrderFilter,
  setOrderStatusFilters,
  setOrderTypeFilters,
  setSelectedDate
} = ordersSlice.actions;
